module.exports = __webpack_public_path__ + "static/media/barmag2b2.e7ca67d2.jpg";